//----------------------------------
// create new character skill entry
//----------------------------------
export default function createNewCharacterSkillEntry({
   id, // temp id used for tracking
  static_skill,
  ticks,
  training,
  display_name = null,
  character = null,
} = {}) {
  console.log('---------------------------------')
  console.log('IN createNewCharacterSkillEntry')

  let character_id = null
  if (character && typeof character === 'object') {
    character_id = character.id
  }
  //------------------
  // define structure
  //------------------
  let skill = {
    // ids
    id: id, // temp id used for tracking
    skill: static_skill.id,

    // only include character id for new skill
    ...(character ? { character: character_id } : {}),

    // optional override for name (e.g., runecasting)
    display_name: display_name,

    // from static skill
    name: static_skill.name,
    category: static_skill.category,
    type: static_skill.type,
    group: static_skill.group,
    parent: static_skill.parent,

    parent_name: static_skill.parent ? static_skill.parent.name : null,
    parent_formula: static_skill.parent ? static_skill.parent.formula : null,

    formula: static_skill.formula,

    formula_arg1: static_skill.formula_arg1,
    formula_arg2: static_skill.formula_arg2,
    formula_arg3: static_skill.formula_arg3,
    formula_oper1: static_skill.formula_oper1,
    formula_oper2: static_skill.formula_oper2,

    default: static_skill.default,
    tickable: static_skill.tickable,
    dex_based: static_skill.dex_based,

    // improvements (from SkillCard or character-rune addition, if not child skill)
    ticks: ticks,
    training: training,

    // calced
    cur: 0,
    cur_no_adjs: 0,
    incr_percent: 0,
    base: 0,
    ticks_max: 0,
    capped_ticks: 0,
    capped_skill: 0,

    // arrays
    character_skill_adjs: [],
    characteristic_skill_adjs: [],
    integrated_rune_skill_adjs: [],

    // adjs tots
    adjs_tot: 0,
    adjs_tot_character_skill: 0,
    adjs_tot_characteristic_skill: 0,
    adjs_tot_integrated_rune_skill: 0,

    // adjs tots reasons (applied)
    adjs_reasons_character_skill: '',
    adjs_reasons_characteristic_skill: '',
    adjs_reasons_integrated_rune_skill: '',

    // adjs tots reasons (optional)
    adjs_reasons_character_skill_opt: '',
  }
  return skill
}
